import React from 'react';
import { useSelector } from 'react-redux';
import { selectAddress, selectAddressShort, selectNftSelected } from '../../store/userStore';
import { Button } from '../common';
import { IMenuHeaderProps } from './MenuHeader';

export const MenuAvatar = (props: IMenuHeaderProps) => {
  const selectedNft = useSelector(selectNftSelected);
  const accountAddressShort = useSelector(selectAddressShort);
  const accountAddress = useSelector(selectAddress);

  const onClickCopyAddress = () => {
    navigator.clipboard.writeText(accountAddress as string);
  };

  return (
    <div className="avatar-container">
      <div className="avatar-container-column">
        <div className="avatar-img-container">
          {selectedNft ? (
            <span className="avatar-img">
              {' '}
              <img alt={selectedNft.nftName} src={selectedNft.nftImg} />{' '}
            </span>
          ) : (
            <span className="avatar-img avatar-overlay" onClick={props.headerActions.setSelectDegen}>
              {' '}
              <img alt="genericDegen" src="https://stacksdegens.com/SDGU/StacksPunks/images/1.png" />{' '}
            </span>
          )}

          <div className="avatar-dropdown">
            <div className="avatar-drop-container">
              <div className="avatar-drop-degen">{selectedNft ? selectedNft.nftName : 'No Degen selected'}</div>
              <div className="avatar-drop-wallet">
                <div className="account-short">
                  <span>{accountAddressShort}</span>
                  <span className="account-copy" data-tooltip="Copy" onClick={onClickCopyAddress}>
                    <svg
                      stroke="currentColor"
                      fill="none"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      height="18px"
                      width="18px"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                    </svg>
                  </span>
                </div>
                <div className="account-logout">
                  <Button className="btn-anchor" label={'Log Out wallet'} onClick={props.headerActions.logOut} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="avatar-actions">
          {selectedNft ? (
            <div className="avatar-degen-selected">{selectedNft.nftName}</div>
          ) : (
            <Button className="btn-anchor" label={'Select Degen'} onClick={props.headerActions.setSelectDegen} />
          )}
        </div>
      </div>
    </div>
  );
};
